import React from 'react'
import { useTranslation } from 'react-i18next'

export default function AboutSettings() {
  const { t } = useTranslation('settings')
  return (
    <div>{t('church.aboutControl')}</div>
  )
}
